import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RateLimitsTab = ({ token }) => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ endpoint_pattern: '', max_requests: 60, window_seconds: 60 });

  const headers = { Authorization: `Bearer ${token}` };

  const fetchRules = async () => {
    try {
      const res = await axios.get('/api/admin/rate-limits', { headers });
      setRules(res.data.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchRules(); }, [token]);

  const createRule = async () => {
    try {
      await axios.post('/api/admin/rate-limits', form, { headers });
      setShowModal(false);
      setForm({ endpoint_pattern: '', max_requests: 60, window_seconds: 60 });
      fetchRules();
    } catch (e) { alert('Hata: ' + (e.response?.data?.error?.message || e.message)); }
  };

  const toggleRule = async (id, currentActive) => {
    try {
      await axios.put(`/api/admin/rate-limits/${id}`, { is_active: !currentActive }, { headers });
      fetchRules();
    } catch (e) { console.error(e); }
  };

  const deleteRule = async (id) => {
    if (!window.confirm('Bu kuralı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/rate-limits/${id}`, { headers });
      fetchRules();
    } catch (e) { console.error(e); }
  };

  if (loading) return <div className="empty">Yükleniyor...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, color: '#FFFFFF', fontSize: '18px' }}>⚡ Rate Limit Kuralları</h3>
        <button className="btn-approve" onClick={() => setShowModal(true)}>+ Yeni Kural</button>
      </div>

      {rules.length === 0 ? (
        <div className="empty">Henüz kural yok</div>
      ) : rules.map(r => (
        <div key={r.id} className="item-card" style={{ marginBottom: '8px' }}>
          <div>
            <div className="item-header">
              <code style={{ color: '#60A5FA' }}>{r.endpoint_pattern}</code>
              <span className={`badge ${r.is_active ? 'active' : 'inactive'}`}>{r.is_active ? 'Aktif' : 'Pasif'}</span>
            </div>
            <div className="item-details">
              <span>Limit: <strong style={{ color: '#E5E7EB' }}>{r.max_requests}</strong> istek / {r.window_seconds}s</span>
            </div>
          </div>
          <div className="item-actions">
            <button className="btn-toggle" onClick={() => toggleRule(r.id, r.is_active)}>
              {r.is_active ? 'Pasif Yap' : 'Aktif Yap'}
            </button>
            <button className="btn-delete" onClick={() => deleteRule(r.id)}>Sil</button>
          </div>
        </div>
      ))}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3>⚡ Yeni Rate Limit Kuralı</h3>
            <div className="form-group">
              <label>Endpoint Pattern</label>
              <input value={form.endpoint_pattern} onChange={e => setForm({ ...form, endpoint_pattern: e.target.value })} placeholder="/api/mobile/*" />
              <small style={{ color: '#6B7280', fontSize: '12px' }}>Wildcard için * kullanın: /api/mobile/auth/*</small>
            </div>
            <div className="form-group">
              <label>Maksimum İstek</label>
              <input type="number" value={form.max_requests} onChange={e => setForm({ ...form, max_requests: parseInt(e.target.value) })} />
            </div>
            <div className="form-group">
              <label>Zaman Aralığı (saniye)</label>
              <input type="number" value={form.window_seconds} onChange={e => setForm({ ...form, window_seconds: parseInt(e.target.value) })} />
            </div>
            <div className="modal-actions" style={{ marginTop: '20px' }}>
              <button className="btn-cancel" onClick={() => setShowModal(false)}>İptal</button>
              <button className="btn-approve" onClick={createRule} disabled={!form.endpoint_pattern}>Ekle</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RateLimitsTab;
